import React from 'react';
import { Button, Divider, Header, Icon, Loader, Popup, Table } from 'semantic-ui-react';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';
import { toast, ToastContainer } from 'react-toastify';
import AddNewStudentMobilityInternship from './AddNewStudentMobilityInternship';
import axios from 'axios';
import moment from 'moment';
import EditStudentMobilityIntership from './EditStudentMobilityInternship';

export default class StudentMobilityIntership extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            internships: [],
            internship: {},
            showEditMode: false,
            mob: JSON.parse(localStorage.getItem('mob')),
            limitation: this.props.limitation,
        };
        this.getMobilityInternship = this.getMobilityInternship.bind(this);
        this.deleteInternship = this.deleteInternship.bind(this);
    }

    componentDidMount() {
        this.getMobilityInternship();
    }

    getMobilityInternship() {
        this.setState({ loader: true });
        axios.get(`/student-mobility-internship/${this.state.mob.id}/`)
            .then(res => {
                let internships = res.data;
                this.setState({ internships });
                this.setState({ loader: false });
            });
    }

    deleteInternship(internshipId, optLock) {
        this.setState({ loader: true });
        let obj = {
            id: internshipId,
            optLock
        };
        axios.delete(`/student-mobility-internship/delete/${internshipId}/`, { data: obj })
            .then((res) => {
                this.setState({ loader: false, confirmation: false });
                toast('Uspješno ste izbrisali praksu!');
                this.getMobilityInternship();
            }).catch(err => {
                this.setState({ loader: false });
                toast('Došlo je do greške! Praksa nije izbrisana!');
            });
    }

    render() {
        return (<div>
            <Divider horizontal>
                <Header as="h4">{this.state.mob.universityName}<br />
                    <span style={{ fontSize: '13px', fontWeight: 'normal' }}><i>{this.state.mob.country.officialName}</i></span>
                </Header>
            </Divider>

            {!this.state.onButtonClick && !this.state.limitation && !this.state.showEditMode ?
                <Header style={IconHeader} floated="right">
                    <Button
                        floated="right"
                        icon
                        disabled={this.state.limitation || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                        labelPosition="right"
                        color="blue"
                        style={FiltersOnStyle}
                        onClick={() => { this.setState({ addIntership: true, onButtonClick: true }); window.scrollTo(0, 0); }}
                    ><Icon className="add" />
                        Dodaj praksu
                    </Button></Header>
                : !this.state.limitation && <br />}

            {this.state.addIntership && <AddNewStudentMobilityInternship
                getMobilityInternship={this.getMobilityInternship}
                closeAddMode={() => this.setState({ addIntership: false, onButtonClick: false })}
            />}


            {this.state.showEditMode &&
                <EditStudentMobilityIntership
                    closeEditMode={() => this.setState({ showEditMode: false })}
                    internship={this.state.internship}
                    getMobilityInternship={this.getMobilityInternship}
                />}

            {(this.state.internships.length && !this.state.limitation) ? <div><br /><br /></div> : ''}
            {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                this.state.internships.length ?
                    <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>
                                <Table.HeaderCell colSpan="2"><Header as="h4" image>
                                    <Header.Content>
                                        Institucija
                                        <Header.Subheader>B/H/S / engleski jezik / izvorni jezik</Header.Subheader>
                                    </Header.Content>
                                </Header></Table.HeaderCell>
                                <Table.HeaderCell >Datum početka</Table.HeaderCell>
                                <Table.HeaderCell>Datum kraja</Table.HeaderCell>
                                <Table.HeaderCell >Opis</Table.HeaderCell>
                                <Table.HeaderCell >Komentar</Table.HeaderCell>
                                <Table.HeaderCell colSpan={1} />
                            </Table.Row>
                        </Table.Header>

                        <Table.Body> {this.state.internships.map((el, index) =>
                            (<Table.Row key={index}>
                                <Table.Cell verticalAlign="middle"colSpan={2}>
                                    {el.institutionName} / { el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].institutionName : '-'} / { el.translations.filter((e) => e.language !== 'en' && this.state.otherLang !== 'en')[0] ? el.translations.filter((e) => e.language !== 'en')[0].institutionName : el.translations.filter((e) => e.language === 'en' && this.state.mob.translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0] ? el.translations.filter((e) => e.language === 'en' && this.state.mob.translations.find((f) => f.originalLanguage === true && f.language === 'en'))[0].institutionName : '-'}
                                    {/* {el.institutionName} / {el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].institutionName : '-'} / { el.translations.filter((e) => e.language !== 'en' && this.state.otherLang !== 'en')[0] ? el.translations.filter((e) => e.language !== 'en')[0].institutionName : el.translations.filter((e) => e.language === 'en')[0] ? el.translations.filter((e) => e.language === 'en')[0].institutionName : '-'} */}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {moment(el.dateStart).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {moment(el.dateEnd).format('D. M. YYYY.')}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle">
                                    {el.description}
                                </Table.Cell>
                                <Table.Cell verticalAlign="middle" >
                                    {el.comment}
                                </Table.Cell>
                                <Table.Cell textAlign="center" verticalAlign="middle" colSpan={1}>
                                    {this.state.confirmation === index ?
                                        <div>
                                            <h4>Jeste li sigurni?</h4>
                                            <Button.Group>
                                                <Button
                                                    basic="true"
                                                    color="blue"
                                                    onClick={() => this.deleteInternship(el.id, el.optLock)}
                                                > DA</Button>
                                                <Button
                                                    basic="true"
                                                    color="red"
                                                    onClick={(e) => { this.setState({ confirmation: false }); }}
                                                >  NE

                                                </Button>
                                            </Button.Group></div>
                                        : <div>
                                            <Popup
                                                content="Izmjena prakse"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                        id={index}
                                                        basic="true"
                                                        circular
                                                        icon="pencil"
                                                        size="small"
                                                        color="green"
                                                        onClick={() => { this.setState({ showEditMode: true, internship: el }); window.scrollTo(0, 0); }}
                                                    />}
                                            />
                                            <Popup
                                                content="Brisanje prakse"
                                                position="top center"
                                                trigger={
                                                    <Button
                                                        disabled={localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu'}
                                                        basic="true"
                                                        circular
                                                        icon="trash alternate"
                                                        size="small"
                                                        color="red"
                                                        onClick={() => this.setState({ confirmation: index })}
                                                    />}
                                            /></div>}
                                </Table.Cell>
                            </Table.Row>))}
                        </Table.Body>
                    </Table>
                    : <div><br /><br />Nema unesenih podataka o praksi koju je student obavio na odabranoj mobilnosti.</div>}
            <ToastContainer hideProgressBar />
        </div>);
    }
}



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/StudentMobilityInternship.js